import type { KeyboardEvent } from "react";

/**
 * onKeyDown for a search / type-ahead box that sits inside a <form>.
 *
 * Browsers submit the enclosing form when Enter is pressed in a text input ("implicit submission").
 * In a live search box that saves the form with the OLD selection while the user is still
 * searching (external audit a025747a F1). Search boxes here are live, so Enter has nothing to do.
 * IME composition (e.g. Japanese input) uses Enter to confirm text; leave that alone.
 */
export const preventEnterSubmit = (e: KeyboardEvent<HTMLInputElement>) => {
  if (e.key === "Enter" && !e.nativeEvent.isComposing) {
    e.preventDefault();
  }
};
